export const hiClinical = {
  consult: {
    readyTitle: 'ट्रांस्क्राइब करने के लिए तैयार',
    readyBody: 'परामर्श कैप्चर करने के लिए रिकॉर्डिंग शुरू करें',
    consultLanguage: 'परामर्श भाषा',
    transcriptionLanguage: 'परामर्श भाषा',
    outputLanguage: 'नोट्स भाषा',
    outputLanguageHint: 'AI नोट्स और विश्लेषण नोट्स भाषा में लिखे जाएंगे',
    consultLanguageLocked: 'आपकी योजना में शामिल नहीं है',
    startRecording: 'रिकॉर्डिंग शुरू करें',
    uploadWav: 'WAV अपलोड करें (Dev)',
    uploading: 'रिकॉर्डिंग अपलोड हो रही है...',
    transcribing: 'ऑडियो ट्रांस्क्राइब हो रहा है...',
    analyzing: 'परामर्श विश्लेषित हो रहा है...',
    complete: 'पूर्ण!',
    processing: 'प्रसंस्करण...',
    uploadingHint: 'ऑडियो सर्वर पर भेजा जा रहा है',
    transcribingHint: 'भाषण को पाठ में बदला जा रहा है',
    analyzingHint: 'नैदानिक अंतर्दृष्टि बनाई जा रही हैं',
    completeHint: 'समाप्त किया जा रहा है',
    processingHint: 'कृपया प्रतीक्षा करें',
    initializing: 'आरंभ हो रहा है...',
    initializingHint: 'ऑडियो कनेक्शन सेट हो रहा है',
    recording: 'रिकॉर्डिंग',
    paused: 'रोका गया',
    resume: 'फिर से शुरू करें',
    pause: 'रोकें',
    stop: 'रोकें',
    recordingPaused: 'रिकॉर्डिंग रोकी गई',
    recordingAudio: 'परामर्श ऑडियो रिकॉर्ड हो रहा है...',
    stopWhenFinished: 'समाप्त होने पर रोकें पर क्लिक करें',
    stopped: 'रुका',
    startNewRecording: 'नई रिकॉर्डिंग शुरू करें',
    recordingComplete: 'रिकॉर्डिंग पूर्ण',
    insertHint: 'ट्रांस्क्राइब और विश्लेषण के लिए "नोट्स में डालें" पर क्लिक करें',
    insertToNotes: 'नोट्स में डालें',
    consentTitle: 'रोगी सहमति आवश्यक',
    consentBody:
      'चिकित्सा ट्रांस्क्रिप्शन के लिए रिकॉर्डिंग सत्र शुरू करने से पहले पुष्टि करें कि आपने रोगी से उचित सहमति ले ली है।',
    consentCheckbox:
      'मैं पुष्टि करता/करती हूँ कि मैंने इस चिकित्सा परामर्श की ऑडियो रिकॉर्डिंग और ट्रांस्क्रिप्शन के लिए रोगी से उचित सहमति ले ली है।',
    acknowledge: 'स्वीकार करें',
    startTitle: 'रिकॉर्डिंग शुरू करें',
    startBody: 'क्या आप वाकई रिकॉर्डिंग शुरू करना चाहते हैं? इससे ट्रांस्क्रिप्शन के लिए आपके माइक्रोफ़ोन से ऑडियो कैप्चर होगा।',
    yesStart: 'हाँ, रिकॉर्डिंग शुरू करें',
    privateNotes: 'निजी टिप्पणियाँ',
    saving: '(सहेजा जा रहा है...)',
    privateNotesPlaceholder: 'इस रोगी के बारे में निजी टिप्पणियाँ जोड़ें...',
    visitsTitle: 'सभी दौरों की समयरेखा',
    loadingHistory: 'रोगी इतिहास लोड हो रहा है...',
    sessionNumber: 'सत्र #{id}',
    appointmentTime: 'अपॉइंटमेंट समय: {time}',
    noPreviousVisits: 'इस रोगी के लिए कोई पिछला दौरा नहीं मिला।',
    languageUpdateFailed: 'परामर्श भाषा अपडेट नहीं हो सकी',
    inConsultSaved: 'परामर्श-कालीन डेटा सहेजा गया',
    inConsultSaveFailed: 'परामर्श-कालीन डेटा सहेजा नहीं जा सका',
    signedOff: 'सत्र साइन-ऑफ होकर समाप्त हो गया।',
    endFailed: 'सत्र समाप्त नहीं हो सका। कृपया पुनः प्रयास करें।',
    noAudio: 'कोई ऑडियो रिकॉर्ड नहीं हुआ',
    analysisFailed: 'पुनः प्रयासों के बाद भी विश्लेषण विफल — कृपया पुनः प्रयास करें',
    transcribed: 'रिकॉर्डिंग ट्रांस्क्राइब और विश्लेषित हो गई',
    processFailed: 'रिकॉर्डिंग संसाधित नहीं हो सकी',
    recovered: 'पुनर्प्राप्त रिकॉर्डिंग ट्रांस्क्राइब और विश्लेषित हो गई',
    recoverFailed: 'रिकॉर्डिंग पुनर्प्राप्त नहीं हो सकी',
    wavDone: 'WAV फ़ाइल ट्रांस्क्राइब और विश्लेषित हो गई',
    wavFailed: 'WAV अपलोड संसाधित नहीं हो सका',
    alreadySignedOff: 'सत्र पहले ही साइन-ऑफ हो चुका है',
    alreadySignedOffBody:
      'यह सत्र साइन-ऑफ हो चुका है, इसलिए इसकी दवाएँ स्वीकृत हैं। स्क्राइब दोबारा चलाने से स्वीकृत नुस्खे बदल या दोहराए जा सकते हैं। केवल तभी जारी रखें जब आप इस परामर्श के रिकॉर्ड अपडेट करना चाहते हों।',
    rerunScribe: 'स्क्राइब फिर चलाएँ',
    endTitle: 'सत्र समाप्त करें और साइन-ऑफ करें?',
    endBody: 'यह परामर्श को अंतिम रूप देता है और नोट को क्लिनिक सिस्टम में भेजता है।',
    endConfirm: 'सत्र समाप्त करें',
    sectionLoading: 'विश्लेषण हो रहा है...',
    sectionFailed: 'विश्लेषण विफल, पिछले नोट्स दिखाए जा रहे हैं',
    analyzingProgressive: 'नोट्स अनुभाग-दर-अनुभाग बनाए जा रहे हैं...',
    analyzingProgressiveHint: 'हर अनुभाग तैयार होते ही दिखाई देगा',
    runInProgress: 'स्क्राइब विश्लेषण अभी चल रहा है। कृपया सभी अनुभागों के पूरा होने की प्रतीक्षा करें।',
    scribeAgents: {
      history: 'इतिहास',
      examination: 'परीक्षण',
      diagnosis: 'निदान',
      medication: 'दवाएँ',
      eq: 'संबंध अनुस्मारक',
      followup: 'फ़ॉलो-अप',
    },
  },
  workspace: {
    tabs: {
      preClerk: 'प्री-क्लर्क',
      inConsult: 'परामर्श में',
      workflow: 'वर्कफ़्लो',
      sessionSummary: 'सत्र सारांश',
      chroniq: 'Chroniq',
      clinicalSummary: 'नैदानिक सारांश',
      careGaps: 'देखभाल अंतराल',
    },
    careGaps: {
      title: 'देखभाल अंतराल',
      subtitle: 'हस्ताक्षरित विज़िट के आधार पर लक्ष्य बनाम वर्तमान रोग गतिविधि',
      ruleset: 'नियम सेट {version}',
      openCount: '{count} खुले',
      onTarget: 'लक्ष्य पर',
      reevaluate: 'पुनर्मूल्यांकन',
      reevaluating: 'मूल्यांकन हो रहा है…',
      loading: 'देखभाल अंतराल जाँचे जा रहे हैं…',
      empty: 'लक्ष्य पर। कोई खुला देखभाल अंतराल नहीं।',
      silent: 'इंजन मौन रूप से मूल्यांकन कर रहा है। इस क्लिनिक के लिए प्रदर्शन चालू होने पर अंतराल यहाँ दिखेंगे।',
      showHistory: '{count} हल किए गए या बंद दिखाएँ',
      hideHistory: 'हल किए गए और बंद छिपाएँ',
      recorded: 'दर्ज',
      noScore: 'कोई गतिविधि स्कोर दर्ज नहीं',
      targetNotMet: 'लक्ष्य पूरा नहीं',
      targetMet: 'लक्ष्य पूरा',
      targetUnknown: 'लक्ष्य: निर्धारित नहीं किया जा सकता',
      action: 'सुझाई गई कार्रवाई',
      due: 'देय {date}',
      closedOn: 'बंद {date}',
      close: 'अंतराल बंद करें',
      exception: 'अपवाद जोड़ें',
      rule: {
        measurementMissing: 'रोग गतिविधि स्कोर दर्ज नहीं है',
        aboveTarget: 'रोग गतिविधि लक्ष्य से ऊपर',
      },
      disease: { ra: 'RA', psa: 'PsA', axspa: 'axSpA', sle: 'SLE' },
      status: {
        open: 'खुला',
        resolved: 'हल',
        excepted: 'अपवाद',
        closed: 'बंद',
        withdrawn: 'वापस लिया',
      },
      dialog: {
        closeTitle: 'देखभाल अंतराल बंद करें',
        closeHint: 'यह प्रमाण दर्ज करें कि बंद करने की शर्त पूरी हो गई है।',
        evidenceLabel: 'बंद करने का प्रमाण',
        evidencePlaceholder: 'जैसे आज CDAI 8 दर्ज; लक्ष्य प्राप्त',
        confirmClose: 'अंतराल बंद करें',
        exceptionTitle: 'अपवाद दर्ज करें',
        exceptionHint: 'व्यक्तिगत लक्ष्य या वर्तमान गतिविधि को स्वीकार करने का दर्ज कारण। अपवाद समाप्त होने तक अंतराल दबा रहेगा।',
        rationaleLabel: 'कारण',
        rationalePlaceholder: 'जैसे गर्भावस्था: ट्रीट-टू-टार्गेट स्थगित; 20 सप्ताह पर समीक्षा',
        expiresLabel: 'समीक्षा की अंतिम तिथि',
        expiresHint: 'भविष्य की तिथि होनी चाहिए, अधिकतम 12 महीने।',
        confirmException: 'अपवाद सहेजें',
        cancel: 'रद्द करें',
        saving: 'सहेजा जा रहा है…',
      },
      errors: {
        displayOff: 'इस क्लिनिक के लिए देखभाल अंतराल अभी चालू नहीं हैं।',
        evidenceRequired: 'बंद करने का प्रमाण आवश्यक है।',
        rationaleRequired: 'कारण आवश्यक है।',
        notFound: 'यह देखभाल अंतराल अब खुला नहीं है।',
        invalidException: 'अपवाद 12 महीनों के भीतर भविष्य की तिथि पर समाप्त होना चाहिए।',
        generic: 'देखभाल अंतराल अपडेट नहीं हो सके। कृपया पुनः प्रयास करें।',
      },
    },
    subTabs: {
      history: 'इतिहास (Hx)',
      exam: 'परीक्षण',
      dx: 'Dx/आकलन',
      plan: 'योजना / Mx',
      billing: 'बिलिंग और ऑर्डर',
      pro: 'PRO',
      aiScribe: 'AI स्क्राइब',
    },
    headings: {
      practitionerNotes: 'चिकित्सक नोट्स',
      practitionerNotesEmpty: 'कोई चिकित्सक नोट नहीं। जोड़ने के लिए क्लिक करें।',
      practitionerNotesPlaceholder: 'नोट जोड़ने के लिए क्लिक करें...',
      hpi: 'वर्तमान रोग का इतिहास',
      hpiPlaceholder: 'वर्तमान रोग का इतिहास दर्ज करें...',
      hpiEmpty: 'वर्तमान रोग का इतिहास दर्ज नहीं है। जोड़ने के लिए क्लिक करें।',
      ros: 'प्रणाली समीक्षा',
      rosPlaceholder: 'प्रणाली समीक्षा दर्ज करें (जैसे, सामान्य: बुखार से इनकार...)',
      rosEmpty: 'प्रणाली समीक्षा दर्ज नहीं है। जोड़ने के लिए क्लिक करें।',
      pastMedicalHx: 'पूर्व चिकित्सा इतिहास',
      pastMedicalHxPlaceholder: 'पूर्व चिकित्सा इतिहास दर्ज करें...',
      pastMedicalHxEmpty: 'कोई पूर्व चिकित्सा इतिहास नहीं। जोड़ने के लिए क्लिक करें।',
      pastSurgicalHx: 'पूर्व शल्य इतिहास',
      pastSurgicalHxPlaceholder: 'पूर्व शल्य इतिहास दर्ज करें...',
      pastSurgicalHxEmpty: 'कोई पूर्व शल्य इतिहास नहीं। जोड़ने के लिए क्लिक करें।',
      familyHistory: 'पारिवारिक इतिहास',
      familyHistoryAdd: 'जोड़ें',
      familyHistoryAddTitle: 'परिवार का सदस्य जोड़ें',
      familyHistoryEmpty: 'कोई पारिवारिक इतिहास नहीं',
      familyHistoryEmptyHint: 'परिवार वृक्ष में रोगी (प्रोबैंड) जोड़कर शुरू करें।',
      familyHistoryStart: 'परिवार वृक्ष शुरू करें',
      familyHistoryExpanded: 'पारिवारिक इतिहास - विस्तृत दृश्य',
      familyHistoryMale: 'पुरुष',
      familyHistoryFemale: 'महिला',
      familyHistoryAffected: 'प्रभावित',
      familyHistoryDeceased: 'मृत',
      medsAllergies: 'दवाएँ और एलर्जी',
      medications: 'दवाएँ:',
      medicationsPlaceholder: 'वर्तमान दवाएँ दर्ज करें...',
      medicationsEmpty: 'कोई दवा दर्ज नहीं है। जोड़ने के लिए क्लिक करें।',
      allergies: 'एलर्जी:',
      allergiesPlaceholder: 'एलर्जी दर्ज करें...',
      allergiesEmpty: 'कोई एलर्जी दर्ज नहीं है। जोड़ने के लिए क्लिक करें।',
      socialHistory: 'सामाजिक इतिहास',
      socialHistoryPlaceholder: 'सामाजिक इतिहास दर्ज करें...',
      socialHistoryEmpty: 'कोई सामाजिक इतिहास दर्ज नहीं है। जोड़ने के लिए क्लिक करें।',
      historySection: 'इतिहास',
      rosPlaceholderBrief: 'प्रणाली समीक्षा दर्ज करें...',
      hpiEmptyBrief: 'वर्तमान रोग का इतिहास दर्ज नहीं है।',
      rosEmptyBrief: 'प्रणाली समीक्षा दर्ज नहीं है।',
      pastMedicalHxEmptyBrief: 'कोई पूर्व चिकित्सा इतिहास नहीं।',
      pastSurgicalHxEmptyBrief: 'कोई पूर्व शल्य इतिहास नहीं।',
      medicationsEmptyBrief: 'कोई दवा दर्ज नहीं है।',
      socialHistoryEmptyBrief: 'कोई सामाजिक इतिहास दर्ज नहीं है।',
      copyToClipboard: 'क्लिपबोर्ड पर कॉपी करें',
    },
    left: {
      mrn: 'MRN',
      noMrn: 'MRN उपलब्ध नहीं',
      noName: 'नाम उपलब्ध नहीं',
      ageGender: 'आयु / लिंग',
      lastVisit: 'अंतिम दौरा',
      noPreviousVisits: 'कोई पिछला दौरा नहीं',
      privateNote: 'निजी नोट',
      privateNotePlaceholder: 'नैदानिक संदर्भ जोड़ें...',
      activeProblems: 'सक्रिय समस्याएँ',
      noActiveProblems: 'कोई सक्रिय समस्या उपलब्ध नहीं',
      activeMedications: 'सक्रिय दवाएँ',
      noActiveMedications: 'कोई सक्रिय दवा उपलब्ध नहीं',
      lastInvestigation: 'अंतिम जाँच',
      noData: 'कोई डेटा उपलब्ध नहीं',
      moreOptions: 'अधिक विकल्प',
      edit: 'संपादित करें',
    },
    alerts: {
      title: 'एलर्जी और चेतावनियाँ',
      drugAllergies: 'दवा एलर्जी',
      otherAlerts: 'अन्य चेतावनियाँ',
      noAllergyRecord: 'अभी तक कोई एलर्जी रिकॉर्ड नहीं।',
      noKnownDrugAllergies: 'कोई ज्ञात दवा एलर्जी नहीं',
      addAllergy: 'एलर्जी जोड़ें',
      addAlert: 'चेतावनी जोड़ें',
      allergyPlaceholder: 'दवा और प्रतिक्रिया, जैसे पेनिसिलिन - चकत्ते',
      alertPlaceholder: 'चेतावनी का विवरण',
      medicalAlert: 'चिकित्सा चेतावनी',
      anticoagulation: 'एंटीकोएगुलेशन',
      fromChat: 'प्री-कंसल्ट चैट से',
      recordedByDoctor: 'डॉक्टर द्वारा दर्ज',
      edit: 'संपादित करें',
      remove: 'हटाएँ',
      confirmRemove: 'यह प्रविष्टि हटाएँ?',
      loadFailed: 'एलर्जी और चेतावनियाँ लोड नहीं हो सकीं।',
      saveFailed: 'सहेजा नहीं जा सका: {reason}',
    },
    right: {
      timeline: 'समयरेखा',
      rx: 'RX',
      review: 'समीक्षा',
      ix: 'IX',
      orders: 'ऑर्डर',
      quickRx: 'QUICK RX',
      letters: 'पत्र',
      visitTimeline: 'दौरा समयरेखा',
      loadingHistory: 'रोगी इतिहास लोड हो रहा है...',
      noPreviousVisits: 'कोई पिछला दौरा नहीं मिला।',
      sessionLabel: 'सत्र #{id} - {name}',
      patientFallback: 'रोगी',
      currentlyViewing: 'अभी देख रहे हैं',
      didNotAttend: 'उपस्थित नहीं हुए',
      completed: 'पूर्ण',
      closed: 'बंद',
      consultationComplete: 'परामर्श पूर्ण',
      inProgress: 'प्रगति पर',
    },
    preclerk: {
      patientHistory: 'रोगी इतिहास और लक्षण (AI द्वारा उत्पन्न)',
      noPatientHistory: 'रोगी इतिहास उपलब्ध नहीं',
      ros: 'प्रणाली समीक्षा:',
      noRos: 'प्रणाली समीक्षा उपलब्ध नहीं',
      pastMedical: 'पूर्व चिकित्सीय चिंताएँ:',
      noPastMedical: 'पूर्व चिकित्सीय चिंताएँ उपलब्ध नहीं',
      pastSurgical: 'पूर्व शल्य चिंताएँ:',
      noPastSurgical: 'पूर्व शल्य चिंताएँ उपलब्ध नहीं',
      familyHistory: 'पारिवारिक इतिहास:',
      noFamilyHistory: 'पारिवारिक इतिहास उपलब्ध नहीं',
      drugAllergies: 'दवाएँ और एलर्जी:',
      noDrugAllergies: 'दवाएँ या एलर्जी उपलब्ध नहीं',
      socialHistory: 'सामाजिक इतिहास:',
      noSocialHistory: 'सामाजिक इतिहास उपलब्ध नहीं',
    },
    exam: {
      msk: 'MSK',
      general: 'सामान्य',
      skinHeent: 'त्वचा/HEENT',
      eyes: 'आँखें',
      cvs: 'हृदय',
      respiratory: 'श्वसन',
      abdominal: 'उदर',
      neuro: 'तंत्रिका',
      summary: 'सारांश',
      skinExam: 'त्वचा परीक्षण',
      generalAppearance: 'सामान्य दिखावट',
      skinMucocutaneous: 'त्वचा और म्यूकोक्यूटेनियस',
      examinerSummary: 'परीक्षक का सारांश और प्रभाव',
      diseaseActivity: 'रोग गतिविधि स्कोर और PRO',
      cardiovascular: 'हृदयवाहिका',
      jointExam: 'मस्कुलोस्केलेटल / जोड़ परीक्षण',
      neurological: 'तंत्रिका संबंधी',
      eyesSection: 'आँखें',
      respiratorySection: 'श्वसन',
      abdominalSection: 'उदर',
      lymphoreticular: 'लसीकाजालिका और लार ग्रंथि',
    },
    dx: {
      section: 'निदान / आकलन',
      primary: 'प्राथमिक निदान',
      principal: 'मुख्य समस्या',
      acute: 'तीव्र निदान',
      chronic: 'दीर्घकालिक निदान',
      differential: 'विचार किए गए विभेदक निदान',
      clinicalReasoning: 'नैदानिक तर्क',
      addDiagnosis: 'निदान जोड़ें',
      addAcute: 'तीव्र निदान जोड़ें',
      addChronic: 'दीर्घकालिक निदान जोड़ें',
      addDifferential: 'विभेदक निदान जोड़ें',
      noPrimary: 'प्राथमिक निदान उपलब्ध नहीं',
      noAcute: 'कोई तीव्र निदान नहीं',
      noChronic: 'कोई दीर्घकालिक निदान नहीं',
      noDifferential: 'कोई विभेदक निदान नहीं',
      insights: 'दिशानिर्देशों से नैदानिक अंतर्दृष्टि',
      insightsUpper: 'दिशानिर्देशों से नैदानिक अंतर्दृष्टि',
    },
    ehrChat: {
      title: 'EHR से चैट',
      ready: 'AI सहायक तैयार',
      unavailable: 'अनुपलब्ध',
      initializing: 'शुरू हो रहा है...',
      close: 'चैट बंद करें',
      connecting: 'EHR से जुड़ रहा है...',
      medicationHistory: 'दवा इतिहास',
      medicationHistoryQuery: 'दवा इतिहास दिखाएँ',
      recentLabs: 'हाल की जाँच',
      recentLabsQuery: 'हाल की जाँच का सारांश दें',
      previousVisits: 'पिछले दौरे',
      previousVisitsQuery: 'पिछले दौरे दिखाएँ',
      placeholder: 'रोगी डेटा, दवाओं, परिणामों के बारे में पूछें...',
      send: 'संदेश भेजें',
    },
  },
};
